import { all, create } from 'mathjs';

const MAX = (a, ...args) => {
  const math = create(all);
  return math.max(a, ...args);
};

export default MAX;
